import { AudioRepository } from "../../../domain/audio-repository";
import { Injectable } from "@angular/core";
import { HttpService } from "../../http/http";

@Injectable()
export class AudioRepositoryIml implements AudioRepository {
  constructor(private httpService: HttpService) {}

  /**
   * Download audio file from FS
   * @param url
   * @return {Promise<any>}
   */
  downloadAudioFile(url: string) {
    var options = this.httpService.createDefaultNonAuthRequestOption();

    return this.httpService.getJSON(url, options);
  }

  /**
   * Query server for audio item URL
   * @param audioId
   * @return {Promise<any>}
   */
  getAudioURL(audioId: number) {
    return this.httpService.get(`audioMedia/${audioId}`);
  }
}
